import { render } from "./FAQ.vue?vue&type=template&id=31b72cde"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
script.render = render

export default script